import axios from "axios";

function institutionSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3010";
      axios
        .get(process.env.ROOT_API + "/institutions/search/" + objAux.id, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("institutionSearch: ", error);
    }
  });
}

function createToken(objAux) {

	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3010"
			axios.get(process.env.ROOT_API  + "/create/token").then(result => {
				resolve(result.data.documents)
			}).catch((error) => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('institutionSearch: ', error)
		}
	})
}

function institutionUpdate(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3009";
      axios
        .put(
          process.env.ROOT_API + "/institutions/update/" + objAux.body.id,
          objAux.body, {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("institutionUpdate: ", error);
    }
  });
}

function sendFile(arr, name, token) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3028";
    axios
      .put(process.env.ROOT_API + "/store_file/" + name, arr, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: token
        }
      })
      .then(result => {
        resolve(result.data.documents[0]);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function getImage(id, token) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3027";
      axios
        .get(process.env.ROOT_API + "/get_file/" + id, {
          responseType: "blob",
          headers: {
            "content-type": "multipart/form-data",
            Authorization: token
          }
        })
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in Get Image: ", err);
    }
  });
}

function user_update(objAuxUser) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3017";
      axios
        .put(
          process.env.ROOT_API + "/users/update/" + objAuxUser.id, {
            control: {
              updated_by: objAuxUser.update_by
            },
            logo: objAuxUser.logo
          }, {
            headers: {
              Authorization: objAuxUser.token
            }
          }
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("institutionUpdate: ", error);
    }
  });
}

function userSearch(objAux) {

  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3016";
      axios
        .get(process.env.ROOT_API + "/users/search/" + objAux.user, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("UserSearch: ", error);
    }
  });
}

function person_query(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3034";
      axios
        .put(process.env.ROOT_API + "/persons/query", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error);
        });
    } catch (error) {
      console.log("Person_Query: ", error);
    }
  });
}

function person_update(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3035";
      axios
        .put(
          process.env.ROOT_API + "/persons/update/" + objAux.body.id,
          objAux.body, {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    } catch (error) {
      console.log("Person_Query: ", error);
    }
  });
}

function searchCountry() {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3031";
      axios
        .get(process.env.ROOT_API + "/country/query")
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in searchCountry: ", err);
    }
  });
}

function searchType(objType) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3031";
      axios
        .get(process.env.ROOT_API + "/tenant/category/" + objType.type)
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in searchType: ", err);
    }
  });
}

function searchState(country) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3030";
      axios
        .get(process.env.ROOT_API + "/cities/query/" + country)
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in searchState: ", err);
    }
  });
}

function list_attendances(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3132";
      axios
        .post(process.env.ROOT_API + "/attendances/list", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("list_attendances: ", error);
    }
  });
}

function record_query(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3063";
      axios
        .post(process.env.ROOT_API + "/record/query", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("Record_Query: ", error);
    }
  });
}

function getPatientExist(objData) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3032";
      axios
        .get(process.env.ROOT_API + "/persons/exists/" + objData.email, {
          headers: {
            Authorization: objData.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]._id);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("Error in getResultItem, CRUD Laboratory: ", err);
    }
  });
}

function record_update(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3064";
      axios
        .put(
          process.env.ROOT_API + "/record/update/" + objAux.body.id,
          objAux.body, {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("record_update: ", error);
    }
  });
}

function attendances_search(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3131";
      axios
        .post(process.env.ROOT_API + "/attendances/query", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("attendances_search: ", error);
    }
  });
}

function services_search(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3075";
      axios
        .get(process.env.ROOT_API + "/services/query/" + objAux.name, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("services_search: ", error);
    }
  });
}

function services_insert(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3077";
      axios
        .post(process.env.ROOT_API + "/services/insert", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("services_search: ", error);
    }
  });
}

function services_update(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3076";
      axios
        .put(
          process.env.ROOT_API + "/services/update/" + objAux.id,
          objAux.body, {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("services_search: ", error);
    }
  });
}

function list_consulting_office(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3127";
      axios
        .post(process.env.ROOT_API + "/consulting/office/list", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("list_consulting_office error: ", error);
    }
  });
}

function insert_consulting_office(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3126";
      axios
        .post(process.env.ROOT_API + "/consulting_office/insert", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("insert_consulting_office error: ", error);
    }
  });
}

function update_consulting_office(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3128";
      axios
        .put(
          process.env.ROOT_API + "/consulting_office/update/" + objAux.body.id,
          objAux.body, {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          console.log("error update_consulting_office", error);
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("upate_consulting_office error: ", error);
    }
  });
}

function attendence_query(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3131";

      axios
        .post(process.env.ROOT_API + "/attendances/query", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.code);
        });
    } catch (error) {
      console.log("list_services error: ", error);
    }
  });
}

function specialty_query(objAux) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3131";
    axios
      .post(
        process.env.ROOT_API + "/specialities/query", {}, {
          headers: {
            Authorization: objAux.token
          }
        }
      )
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        console.log("specialty_query error: ", error);
        reject(error.code);
      });
  });
}

function specialty_list_filter(objAux) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3131";
    axios
      .post(process.env.ROOT_API + "/specialities/list", objAux.body, {
        headers: {
          Authorization: objAux.token
        }
      })
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        console.log("specialty_list_filter error: ", error);
        reject(error.code);
      });
  });
}

function deleteDocuments(id, token) {
  return new Promise((resolve, reject) => {
    axios.get(process.env.ROOT_API + "/delete/file/" + id, {
      headers: {
        Authorization: token
      }
    }).then(result => {
      resolve(result.data.documents);
    }).catch(error => {
      reject(error.code)
    })
  })
}

function getImagePhoto(id, token) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3027";
      axios
        .get(process.env.ROOT_API + "/get_file/" + id, {
          responseType: "blob",
          headers: {
            "content-type": "multipart/form-data",
            Authorization: token
          }
        })
        .then(result => {
          let vari = {
            result: result,
            id: id
          }
          resolve(vari);
        })
        .catch(error => {
          reject(error);
        });
    } catch (err) {
      console.log("err in Get Image: ", err);
    }
  });
}


//Payment with Stripe
function stripe_oauth_link(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3132";
      axios
        .post(process.env.ROOT_API + "/stripe-oauth-link", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          // console.log(result)
          resolve(result.data.url);
        })
        .catch(error => {
          console.error(error);
          // reject(error.response.data.message);
        });
    } catch (error) {
      console.log("stripe_oauth_link: ", error);
    }
  });
}

//Update Stripe bank account
function update_bank_account(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3132";
      axios
        .post(process.env.ROOT_API + "/update-bank-account", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          // console.log(result)
          resolve(result.data);
        })
        .catch(error => {
          console.error(error);
          // reject(error.response.data.message);
        });
    } catch (error) {
      console.log("update_bank_account: ", error);
    }
  });
}

//Update variable payment_required
function update_payment_required(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3132";
      axios
        .post(process.env.ROOT_API + "/update-payment-required", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          // console.log(result)
          resolve(result.data);
        })
        .catch(error => {
          console.error(error);
          // reject(error.response.data.message);
        });
    } catch (error) {
      console.log("update_payment_required: ", error);
    }
  });
}

//Update variable payment_required
function get_dashboard_stripe(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3132";
      axios
        .post(process.env.ROOT_API + "/get-dashboard-stripe", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0].url);
        })
        .catch(error => {
          console.error(error);
          // reject(error.response.data.message);
        });
    } catch (error) {
      console.log("update_payment_required: ", error);
    }
  });
}


export {
  specialty_list_filter,
  specialty_query,
  institutionSearch,
  institutionUpdate,
  sendFile,
  getImage,
  user_update,
  userSearch,
  person_query,
  person_update,
  searchCountry,
  searchType,
  searchState,
  record_query,
  record_update,
  getPatientExist,
  services_search,
  services_insert,
  services_update,
  list_consulting_office,
  insert_consulting_office,
  update_consulting_office,
  attendence_query,
  attendances_search,
  list_attendances,
  getImagePhoto,
  deleteDocuments,
  stripe_oauth_link,
  update_bank_account,
  update_payment_required,
  get_dashboard_stripe,
  createToken
};



// WEBPACK FOOTER //
// ./src/components/easyfindme/easyFindMeSev.js